import { Skeleton, Stack } from "@mui/material";
import { ChemicalsTable } from "../../ChemicalsTable";
import { ReportFloatingBar } from "../ReportFloatingBar";
import {
  useChemicalIssues,
  useChemicalStepsIssueCounts,
  useReport,
} from "../useReport";

import { TierIiReportStep } from "generated-graphql/graphql";
import { useProducts } from "hooks/useProducts";
import { useTouchReportMutation } from "../useTouchReportMutation";
import { useNavigateReportSaveCancel } from "../useNavigateReportSaveCancel";

export function ChemicalsReportStep() {
  const { data, loading } = useReport();
  const issues = useChemicalIssues();
  const chemicalStepsIssueCounts = useChemicalStepsIssueCounts();
  const facilityId = data?.tierIIReport.facility.id ?? "";
  const reportId = data?.tierIIReport.id ?? "";
  const navigateToOverview = useNavigateReportSaveCancel();
  const { hasProducts: isOtherChemicals } = useProducts();
  const step = isOtherChemicals
    ? TierIiReportStep.OtherChemicals
    : TierIiReportStep.Chemicals;
  const { handleSave, loading: touchLoading } = useTouchReportMutation(
    reportId,
    data?.tierIIReport.touchedSteps ?? [],
    step
  );

  if (loading) {
    return (
      <>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </>
    );
  }

  return (
    <>
      <Stack
        sx={{
          height: "100%",
          flexDirection: "column",
        }}
      >
        <ChemicalsTable facilityId={facilityId} reportId={reportId} />
      </Stack>
      <ReportFloatingBar
        loading={touchLoading}
        onSaveClick={handleSave}
        onCancel={navigateToOverview}
        issues={issues}
        issueCount={chemicalStepsIssueCounts[TierIiReportStep.Chemicals]}
        disabledWithAnyIssues
        saveText="Mark as Complete"
      />
    </>
  );
}
